"use strict";

var _slicedToArray = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumber = exports.ellipseSentence = exports.ellipseString = void 0;
var PHONE_NUMBER_RE = /\+1(\d{3})(\d{3})(\d{4})/;

function ellipseString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 180;
  var endString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "...";
  return string.length > limit ? "".concat(string.slice(0, limit)).concat(endString) : string;
}

exports.ellipseString = ellipseString;

function ellipseSentence(sentence, upperCharLimit) {
  var endString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "...";
  if (sentence.length <= upperCharLimit) return sentence;
  var trimSentence = sentence.substr(0, upperCharLimit + 1);
  var idx = trimSentence.lastIndexOf(" ");
  trimSentence = trimSentence.substr(0, idx ? idx + 1 : 0);
  return trimSentence + endString;
}

exports.ellipseSentence = ellipseSentence;

function formatPhoneNumber(phoneNumber) {
  var match = phoneNumber.match(PHONE_NUMBER_RE);

  if (!match || !PHONE_NUMBER_RE.test(phoneNumber)) {
    throw new Error("Improperly formatted phone number given");
  }

  var _match$slice = match.slice(1, 4),
      _match$slice2 = _slicedToArray(_match$slice, 3),
      areaCode = _match$slice2[0],
      firstThree = _match$slice2[1],
      lastFour = _match$slice2[2];

  return "(".concat(areaCode, ") ").concat(firstThree, "-").concat(lastFour);
}

exports.formatPhoneNumber = formatPhoneNumber;